import React from 'react';
import type { TenantAgent } from '../../services/tenantAgentsService';

/**
 * The agent a page belongs to, and where it lives: /agents/<address>.
 *
 * A workspace may have several agents of one kind (two Policy Servicing desks),
 * so a page asks which one it is showing rather than assuming by kind, and
 * links within it stay with that agent.
 */
export interface CurrentAgent {
  agent: TenantAgent;
  /** "/agents/policy_servicing", or "/agents/<id>" for a further one of its kind. */
  base: string;
}

const AgentContext = React.createContext<CurrentAgent | null>(null);

export const AgentProvider = AgentContext.Provider;

export function useAgent(): CurrentAgent {
  const current = React.useContext(AgentContext);
  if (!current) throw new Error('useAgent is used outside an agent page');
  return current;
}
